module.exports = __webpack_public_path__ + "img/trash-can-outline-disable.db83f3fb.svg";